import { Component, Inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
    selector: 'app-macros-list',
    templateUrl: './macros-list.component.html',
    styleUrls: ['./macros-list.component.scss'],
    standalone: false
})
export class MacrosListComponent {

  constructor(
    @Inject(NZ_MODAL_DATA) public data: { macrosList: { id: string; name: string; desc: string }[] },
    private dialogRef: NzModalRef<MacrosListComponent>,
  ) { }

  close(): void {
    this.dialogRef.close();
  }

}

